const AOS = require('aos')
const throttle = require('lodash/throttle')
const scrollToElement = require('scroll-to-element')

const initVideoButtons = require('./src/browser-libs/initVideoButtons')
const { initMinSlider, initBaseSliders } = require('./src/browser-libs/initFlickity')
const { initAnnualReviewSlider, initFinancialReportAndPersonnelStructure } = require('./src/browser-libs/initBtnEvents')
const { initGraduatesPieFrom17and18PieChart, initStudentsEnrolledInBechelorDegreeBarChart } = require('./src/browser-libs/initCharts')

function init() {
  // Sliders
  initMinSlider()
  initBaseSliders()

  // BtnEvents to show/hide domEl
  initAnnualReviewSlider()
  initFinancialReportAndPersonnelStructure()

  initVideoButtons()

  // Init charts
  initGraduatesPieFrom17and18PieChart()
  initStudentsEnrolledInBechelorDegreeBarChart()
}

exports.onClientEntry = () => {
  AOS.init()

  window.addEventListener('scroll', throttle(() => {
    AOS.refresh()
  }, 500))

  setTimeout(() => {
    init()
  }, 300)
}

exports.onRouteUpdate = ({ location }) => {
  const hash = location.hash
  if (hash) {
    scrollToElement(hash, {
      offset: -155,
      duration: 200,
    })
  }

  init()
}

exports.shouldUpdateScroll = ({
  routerProps: { location },
  getSavedScrollPosition
}) => {
  const hash = location.hash
  if (hash) {
    scrollToElement(hash, {
      offset: -155,
      duration: 200,
    })
    return false
  }
  return true
}
